import { MSTextInput } from "../textinput/textinput.js";
/**
 * @class MSPassInput
 * @extends MSTextInput
 * @classdesc Пароль
 * */
export class MSPassInput extends MSTextInput {
    constructor() {
        super();
        this._text.type = 'password';
    }
}